import type { AnnotationLabelT, AnswerT } from '../../../common/types/types';
import type { AnnotationT } from '../../labelling/types';
import { createKeyFrame } from '../../labelling/utils';
import type { FramePayload, MetadataPayload } from '../studio-store/types';
const DEFAULT_ANNOTATION_LABEL_STYLE = {
  strokeColor: '',
  fillColor: '',
  fillOpacity: 0,
  strokeWidth: 1
};

// Static answers apply on every frame; dynamic answers are keyed by frame span and merge on top.
export function resolveAnswersForFrame(metadata: Pick<MetadataPayload, 'answers' | 'dynamicAnswers'>, frameIndex: number): AnswerT | undefined {
  const staticAnswers = metadata.answers;
  const dynamicAnswersForFrame = metadata.dynamicAnswers?.find(span => span.frameSpan.start <= frameIndex && frameIndex <= span.frameSpan.end)?.answers;
  return staticAnswers !== undefined || dynamicAnswersForFrame !== undefined ? {
    ...staticAnswers,
    ...dynamicAnswersForFrame
  } : undefined;
}
export function buildAnnotationForOutput(framePayload: FramePayload, metadata: MetadataPayload, annotationLabels: AnnotationLabelT[], frameIndex: number): AnnotationT {
  const label = annotationLabels.find(l => l.title === metadata.labelId) ?? {
    title: metadata.labelId,
    style: DEFAULT_ANNOTATION_LABEL_STYLE
  };
  const answers = resolveAnswersForFrame(metadata, frameIndex);
  const mlData = framePayload.mlState ? {
    state: framePayload.mlState
  } : undefined;
  const originalId = metadata.originalId;
  const annotationSource = metadata.annotationSource;
  const consensusInfo = metadata.consensusInfo;
  const hasMetadata = answers !== undefined || mlData !== undefined || originalId !== undefined || annotationSource !== undefined || consensusInfo !== undefined;
  const annotationMetadata = hasMetadata ? {
    ...(answers !== undefined ? {
      answers
    } : {}),
    ...(mlData !== undefined ? {
      mlData
    } : {}),
    ...(originalId !== undefined ? {
      originalId
    } : {}),
    ...(annotationSource !== undefined ? {
      annotationSource
    } : {}),
    ...(consensusInfo !== undefined ? {
      consensusInfo
    } : {})
  } : undefined;
  return ({
    annotationType: metadata.annotationType,
    annotationLabel: label,
    data: framePayload.geometry,
    keyFrame: createKeyFrame(framePayload.isKeyFrame, framePayload.keyFrameType ?? 'MANUAL'),
    metadata: annotationMetadata
  } as AnnotationT);
}